import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";

function WelcomeMessageCharLimitModal(props) {
  return (
    <BasicModal
      popupOpen={props?.showLimitAlert}
      logo={"/Images/approve-qc.png"}
      bodyMessage={
        <p className="mt-2">
          Character limit exceeded! The preview message cannot be longer than {props?.maxChars ?? 70} characters.
          Please shorten the guest name or the message template.
        </p>
      }
      footer={{
        secondaryButton: {
          buttonName: "OK",
          action: props?.onOk,
          buttonPrimaryCustomCss: "cancel-btn_new",
        },
      }}
    />
  );
}

export default WelcomeMessageCharLimitModal;
